"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@mui/styles");
var _material = require("@mui/material");
var _InsertComment = _interopRequireDefault(require("@mui/icons-material/InsertComment"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _CustomSelect = _interopRequireDefault(require("./CustomSelect"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));
var _AddComment = _interopRequireDefault(require("../../../dist/components/dialogs/AddComment"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _lodash = require("lodash");
var _surveyUtils = require("../../utilities/surveyUtils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    centerText: {
      textAlign: 'center'
    }
  };
};
var CustomDiamBranchingQuestion = /*#__PURE__*/function (_Component) {
  function CustomDiamBranchingQuestion(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CustomDiamBranchingQuestion);
    _this = _callSuper(this, CustomDiamBranchingQuestion, [props]);
    var services = props.services,
      questionData = props.questionData,
      questions = props.questions,
      questionID = props.questionID,
      answers = props.answers;
    var question = questions.find(function (q) {
      return q.questionID == questionID;
    });
    var useDropdown = question.answerID > 0;
    var branchOptions = [];
    if (useDropdown) {
      var answer = answers.find(function (a) {
        return a.answerID === question.answerID;
      });
      if (answer) {
        if (answer.type === 'API') {
          branchOptions = _this.props[answer.apiName];
        } else {
          branchOptions = (0, _lodash.cloneDeep)(answer.answers);
          branchOptions.forEach(function (a) {
            if (_this.props.language && a.translations && a.translations[_this.props.language]) {
              a.label = a.translations[_this.props.language];
            }
          });
        }
      }
    }
    var value = _this.getAnswers(questionData.questions, questionID);
    var branchingRow = {};
    services.forEach(function (s) {
      branchingRow[s.serviceID] = {
        value: {
          label: '',
          value: ''
        },
        valueText: '',
        comment: ''
      };
    });
    value.forEach(function (v) {
      var a = JSON.parse(v);
      var rowValue = branchOptions.find(function (o) {
        return o.value == a.rowValue;
      });
      var services = a.services;
      services.forEach(function (s) {
        if (s.checked) {
          branchingRow[s.serviceID] = {
            value: rowValue ? rowValue : {
              label: '',
              value: ''
            },
            valueText: a.rowValueText,
            comment: s.comment
          };
          props.setBranchingQuestions([].concat(props.parentQuestionIDs, [questionID]), s.serviceID, branchingRow[s.serviceID]);
        }
      });
    });
    _this.state = {
      showCommentDialog: false,
      clickedServiceID: '',
      commentVal: '',
      question: question,
      branchOptions: branchOptions,
      branchingRow: branchingRow,
      services: (0, _lodash.cloneDeep)(services)
    };
    ['getAnswers', 'handleAddComment', 'convertToValue'].map(function (item) {
      return _this[item] = _this[item].bind(_this);
    });
    return _this;
  }
  (0, _inherits2["default"])(CustomDiamBranchingQuestion, _Component);
  return (0, _createClass2["default"])(CustomDiamBranchingQuestion, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(props) {
      var _this2 = this;
      var branchingRow = (0, _lodash.cloneDeep)(this.state.branchingRow);
      var shouldUpdate = false;
      props.services.forEach(function (s) {
        var prevSvcState = _this2.state.services.find(function (ss) {
          return ss.serviceID === s.serviceID;
        });
        if (s.checked !== prevSvcState.checked) {
          branchingRow[s.serviceID].value = {
            label: '',
            value: ''
          };
          branchingRow[s.serviceID].valueText = '';
          branchingRow[s.serviceID].comment = '';
          _this2.props.onBranchingQuestionChange([].concat(props.parentQuestionIDs, [props.questionID]), s.serviceID, branchingRow[s.serviceID]);
          if (!shouldUpdate) shouldUpdate = true;
        }
      });
      if (shouldUpdate) {
        this.setState({
          branchingRow: branchingRow,
          services: (0, _lodash.cloneDeep)(props.services)
        });
      }
    }
  }, {
    key: "convertToValue",
    value: function convertToValue(branchingRow) {
      var values = [];
      Object.keys(branchingRow).forEach(function (serviceID) {
        var row = branchingRow[serviceID];
        var rowValue = row.value ? row.value.value : '';
        if ((rowValue !== '' || row.valueText !== '') && !values.find(function (v) {
          return v.value == rowValue && v.valueText == row.valueText;
        })) {
          values.push({
            value: rowValue,
            valueText: row.valueText
          });
        }
      });
      var value = values.map(function (v) {
        var services = Object.keys(branchingRow).reduce(function (all, serviceID) {
          var row = branchingRow[serviceID];
          var rowValue = row.value ? row.value.value : '';
          if (rowValue === v.value && row.valueText === v.valueText) {
            all.push({
              serviceID: serviceID,
              checked: true,
              comment: row.comment
            });
          }
          return all;
        }, []);
        return JSON.stringify({
          rowValue: v.value,
          rowValueText: v.valueText,
          services: services
        });
      });
      return value;
    }
  }, {
    key: "updateRow",
    value: function updateRow(serviceID) {
      var _this3 = this;
      var _this$props = this.props,
        parentQuestionIDs = _this$props.parentQuestionIDs,
        questionID = _this$props.questionID;
      return function (event, value) {
        var branchingRow = _this3.state.branchingRow;
        branchingRow[serviceID].value = value ? value : {
          label: '',
          value: ''
        };
        _this3.setState({
          branchingRow: branchingRow
        }, function () {
          _this3.props.onBranchingQuestionChange([].concat(parentQuestionIDs, [questionID]), serviceID, branchingRow[serviceID]);
        });

        //let val = this.convertToValue(branchingRow);
        //this.props.onBranchingQuestionChange([...parentQuestionIDs, questionID], val);
      };
    }
  }, {
    key: "updateText",
    value: function updateText(serviceID) {
      var _this4 = this;
      var _this$props2 = this.props,
        parentQuestionIDs = _this$props2.parentQuestionIDs,
        questionID = _this$props2.questionID;
      return function (value) {
        var branchingRow = _this4.state.branchingRow;
        branchingRow[serviceID].valueText = value.target.value;
        _this4.setState({
          branchingRow: branchingRow
        }, function () {
          _this4.props.onBranchingQuestionChange([].concat(parentQuestionIDs, [questionID]), serviceID, branchingRow[serviceID]);
        });

        //this.props.onBranchingQuestionChange([...parentQuestionIDs, questionID], val);
      };
    }
  }, {
    key: "getAnswers",
    value: function getAnswers(questionData, questionID) {
      var _this5 = this;
      var answer = [];
      Object.keys(questionData).forEach(function (k) {
        if (k == questionID) {
          answer = questionData[questionID].answer;
        }
        if (questionData[k].questions.length > 0) {
          answer = _this5.getAnswers(questionData[k].questions, questionID);
        }
      });
      return answer;
    }
  }, {
    key: "handleAddComment",
    value: function handleAddComment(value, serviceID) {
      var _this6 = this;
      var _this$props3 = this.props,
        parentQuestionIDs = _this$props3.parentQuestionIDs,
        questionID = _this$props3.questionID;
      var branchingRow = this.state.branchingRow;
      branchingRow[serviceID].comment = value;
      this.setState({
        branchingRow: branchingRow
      }, function () {
        _this6.props.onBranchingQuestionChange([].concat(parentQuestionIDs, [questionID]), serviceID, branchingRow[serviceID]);
      });
    }
  }, {
    key: "getQuestionData",
    value: function getQuestionData(questionData, questionID) {
      var _this7 = this;
      var answer = [];
      Object.keys(questionData).forEach(function (k) {
        if (k == questionID) {
          answer = questionData[questionID];
        }
        if (questionData[k].questions.length > 0) {
          answer = _this7.getQuestionData(questionData[k].questions, questionID);
        }
      });
      return answer;
    }
  }, {
    key: "getBranchingQuestions",
    value: function getBranchingQuestions(parentQuestionNumbers) {
      var _this$state = this.state,
        question = _this$state.question,
        branchingRow = _this$state.branchingRow;
      var _this$props4 = this.props,
        questions = _this$props4.questions,
        answers = _this$props4.answers,
        questionData = _this$props4.questionData,
        parentQuestionIDs = _this$props4.parentQuestionIDs,
        services = _this$props4.services,
        onBranchingQuestionChange = _this$props4.onBranchingQuestionChange,
        language = _this$props4.language,
        setBranchingQuestions = _this$props4.setBranchingQuestions;
      if ((0, _lodash.isEmpty)(question.branchingQuestions)) return;
      var rows = this.convertToValue(branchingRow);
      console.log('nested branching', branchingRow, services);
      var enabledServices = [];
      var branchingQuestions = [];
      rows.forEach(function (v) {
        var a = JSON.parse(v);
        var hasBranching = false;
        if (question.branchingQuestions[a.rowValue]) {
          a.services.forEach(function (s) {
            var parentService = services.find(function (ps) {
              return ps.serviceID === s.serviceID;
            });
            if (parentService && !hasBranching) {
              hasBranching = parentService.checked;
            }
          });
          if (hasBranching) {
            branchingQuestions.push.apply(branchingQuestions, question.branchingQuestions[a.rowValue]);
            a.services.forEach(function (s) {
              if (s.checked && enabledServices.indexOf(s.services) < 0) {
                enabledServices.push(s.serviceID);
              }
            });
          }
        }
      });
      if (branchingQuestions.length === 0) return;
      var branchingQuestionData = this.getQuestionData(questionData.questions, question.questionID);
      var branchingServices = services.map(function (s) {
        return {
          serviceID: s.serviceID,
          checked: !(enabledServices.indexOf(s.serviceID) < 0),
          disabled: s.disabled
        };
      });
      return branchingQuestions.map(function (bq, i) {
        return /*#__PURE__*/_react["default"].createElement(CustomDiamBranchingQuestion, {
          parentQuestionNumbers: parentQuestionNumbers,
          questionNumber: i,
          key: "".concat(bq, "-").concat(i),
          onBranchingQuestionChange: onBranchingQuestionChange,
          services: [].concat(branchingServices),
          questions: questions,
          answers: answers,
          questionData: branchingQuestionData,
          questionID: bq,
          parentQuestionIDs: [].concat(parentQuestionIDs, [question.questionID]),
          language: language,
          setBranchingQuestions: setBranchingQuestions
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;
      var _this$props5 = this.props,
        services = _this$props5.services,
        parentQuestionNumbers = _this$props5.parentQuestionNumbers,
        questionNumber = _this$props5.questionNumber;
      var _this$state2 = this.state,
        question = _this$state2.question,
        branchOptions = _this$state2.branchOptions,
        branchingRow = _this$state2.branchingRow,
        showCommentDialog = _this$state2.showCommentDialog;
      var useDropdown = question.answerID > 0;
      var parentQuestionNumberLabel = parentQuestionNumbers !== null ? "".concat(parentQuestionNumbers.join('.'), ".") : '';
      var questionNumberLabel = "".concat(parentQuestionNumberLabel + (0, _surveyUtils.numberToLetter)(questionNumber), ".");
      if (question) {
        return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.TableRow, null, /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
          style: {
            width: '20%'
          }
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, question.additionalDescription)), services.map(function (d) {
          return /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
            key: d.serviceID
          }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
            container: true
          }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
            item: true,
            xs: 10,
            style: {
              textAlign: 'right'
            }
          }, useDropdown && /*#__PURE__*/_react["default"].createElement(_CustomSelect["default"], {
            label: "",
            disabled: !d.checked || d.disabled,
            name: "branchRowValue",
            options: branchOptions,
            onChange: function onChange(value) {
              return _this8.updateRow(d.serviceID, value);
            },
            value: branchingRow[d.serviceID] && d.checked && !d.disabled ? branchingRow[d.serviceID].value : {
              label: '',
              value: ''
            }
          }), !useDropdown && /*#__PURE__*/_react["default"].createElement(_material.TextField, {
            label: "",
            name: "rowValueText",
            disabled: !d.checked || d.disabled,
            margin: "dense",
            onBlur: _this8.updateText(d.serviceID),
            defaultValue: branchingRow[d.serviceID] && d.checked && !d.disabled ? branchingRow[d.serviceID].valueText : ''
          })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
            item: true,
            xs: 2
          }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
            title: "Add Comment",
            "aria-label": "add"
          }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
            disabled: !d.checked || d.disabled || !branchingRow[d.serviceID] || branchingRow[d.serviceID].value === '' && useDropdown || !useDropdown && branchingRow[d.serviceID].valueText === '',
            "aria-label": "Add Comment",
            onClick: function onClick() {
              return _this8.setState({
                showCommentDialog: true,
                clickedServiceID: d.serviceID,
                commentVal: branchingRow[d.serviceID].comment
              });
            }
          }, /*#__PURE__*/_react["default"].createElement(_InsertComment["default"], {
            color: d.checked && !d.disabled && branchingRow[d.serviceID] && branchingRow[d.serviceID].comment !== '' && branchingRow[d.serviceID].comment !== undefined ? 'primary' : 'default'
          }, branchingRow[d.serviceID] ? branchingRow[d.serviceID].comment : '')))))));
        })), this.getBranchingQuestions([].concat(parentQuestionNumbers, [(0, _surveyUtils.numberToLetter)(questionNumber)])), /*#__PURE__*/_react["default"].createElement(_AddComment["default"], {
          open: showCommentDialog,
          commentVal: this.state.commentVal,
          title: 'Add/Edit Comment',
          contentText: "(Limited to 100 characters)",
          onConfirm: function onConfirm(name) {
            _this8.setState({
              showCommentDialog: false
            });
            _this8.handleAddComment(name, _this8.state.clickedServiceID);
          },
          onClose: function onClose() {
            return _this8.setState({
              showCommentDialog: false
            });
          }
        }));
      }
    }
  }]);
}(_react.Component);
CustomDiamBranchingQuestion.propTypes = {};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(CustomDiamBranchingQuestion);